const moduleConfigs = import.meta.glob("../modules/*/module.json", {
  eager: true,
  import: "default",
});

const routeFiles = import.meta.glob("../modules/*/routes.jsx", { eager: true });

function getModuleRouteFile(moduleDirectory) {
  const routePath = Object.keys(routeFiles).find((path) =>
    path.includes(`/${moduleDirectory}/routes.jsx`),
  );
  return routePath ? routeFiles[routePath] : null;
}

export function getEnabledModules() {
  return Object.entries(moduleConfigs)
    .map(([path, config]) => ({
      ...config,
      moduleDirectory: path.split("/").at(-2),
    }))
    .filter((module) => module.enabled !== false)
    .sort((a, b) => (a.order ?? 999) - (b.order ?? 999));
}

export function getModuleRoutes(parentRoute) {
  return getEnabledModules().flatMap((module) => {
    const getRoutes = getModuleRouteFile(module.moduleDirectory)?.getRoutes;
    return getRoutes ? getRoutes(parentRoute) : [];
  });
}

export function getModuleSidebarAction(moduleId) {
  const module = getEnabledModules().find((item) => item.id === moduleId);
  if (!module) return null;
  return getModuleRouteFile(module.moduleDirectory)?.getSidebarAction?.() ?? null;
}

export function getModuleNavigation() {
  return getEnabledModules().flatMap((module) =>
    (module.sidebar?.items ?? []).map((item) => ({
      ...item,
      moduleId: module.id,
      permission: item.permission ?? `${module.id}.view`,
    })),
  );
}

export function getModuleTopbarItems() {
  return getEnabledModules().flatMap((module) =>
    (module.topbar?.items ?? []).map((item, index) => ({
      ...item,
      id: item.id ?? `${module.id}-topbar-${index}`,
      moduleId: module.id,
      permission: item.permission ?? `${module.id}.view`,
    })),
  );
}

export function orderModuleItems(items, configuredOrder = []) {
  const positions = new Map(configuredOrder.map((id, index) => [id, index]));
  return [...items].sort((left, right) => {
    const leftPosition = positions.get(left.id);
    const rightPosition = positions.get(right.id);
    if (leftPosition === undefined && rightPosition === undefined) return 0;
    if (leftPosition === undefined) return 1;
    if (rightPosition === undefined) return -1;
    return leftPosition - rightPosition;
  });
}
